import { Moment } from 'moment';
import { EmployeeWageType } from './employee-wage-type';
import { DtoForceConstructor } from '@core/utils/dto';
import { copyObjectProperties } from '@core/utils/object';
import { Dto } from '@core/data/dto/dto';
import { DtoExport, DtoImport } from '@core/utils/dto';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { EmployeeWageSchema } from './employee-wage.schema';

@DtoForceConstructor
export class EmployeeWage {
    public id: string;
    public wageType: EmployeeWageType;
    public salary: {
        amount: number;
        hours: number;
    };
    public effective: Moment;
    public approvedBy: {
        id: string;
        name: string;
    };
    public approvedAt: Moment;
    public statusLabel?: string;
    public isUpcoming?: boolean;
    public isActive?: boolean;

    constructor(value?: any) {
        if (value) {
            copyObjectProperties.call(this, value);
        }
    }

    @DtoImport(EmployeeWageSchema)
    static import(dto: Dto): any {
        return new EmployeeWage(dto);
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: EmployeeWage,
        },
    ])
    export(type?: DtoType): any {}
}
